import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts'
import ChartContainer from './ChartContainer'
import { RechartsChartTooltipProvider, StableRechartsChartTooltip } from './ChartTooltip'
import { defaultFormatter } from './formatters'

const BaseLineChart = ({
  data,
  xKey,
  series,
  height = 240,
  loading,
  emptyMessage,
  valueFormatter,
  labelFormatter,
  showLegend = true,
  tooltipExtraContent,
  tooltipClassName,
}) => {
  const empty = !data || data.length === 0
  const normalizedSeries = (series || []).map((item) => ({
    ...item,
    formatter: item.formatter || valueFormatter || defaultFormatter,
  }))

  return (
    <ChartContainer height={height} loading={loading} empty={empty} emptyMessage={emptyMessage}>
      <RechartsChartTooltipProvider
        series={normalizedSeries}
        options={{
          valueFormatter,
          labelFormatter,
          extraContent: tooltipExtraContent,
          className: tooltipClassName,
        }}
      >
        <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
          <CartesianGrid stroke="var(--chart-grid)" strokeDasharray="3 3" />
          <XAxis
            dataKey={xKey}
            stroke="var(--chart-muted)"
            fontSize={11}
            tickLine={false}
            axisLine={{ stroke: 'var(--chart-border)' }}
            minTickGap={24}
            interval="preserveStartEnd"
          />
          <YAxis
            stroke="var(--chart-muted)"
            fontSize={11}
            tickLine={false}
            axisLine={{ stroke: 'var(--chart-border)' }}
          />
          <Tooltip content={StableRechartsChartTooltip} />
          {showLegend && <Legend verticalAlign="top" align="right" iconType="circle" className="rg-chart__legend" />}
          {normalizedSeries.map((item) => (
            <Line
              key={item.key}
              type="monotone"
              dataKey={item.key}
              stroke={`var(${item.colorVar})`}
              strokeWidth={2}
              dot={false}
              name={item.label}
            />
          ))}
        </LineChart>
      </RechartsChartTooltipProvider>
    </ChartContainer>
  )
}

export default BaseLineChart
